import translations from './translations'

translations.add('en', {
    changePaymentMethod: 'change payment method',
    firstTokenizationDescription: 'Card Registration',
    firstVerificationDescription: 'Card Verification',
    secondaryOrderInfoDescription: 'You won\'t be charged',
    tryAgain: 'Try again'
})
